import React from "react";
import Layout from "../pages/Layout";
import HomeIcon from "../assets/icons/home_icon";
import Logo from "../images/bentex-logo.png"

function ReviewPage() {
  return (
    <Layout>
      <div className="review_order">
        <header className="header">
          <h1>Review Order</h1>
          <p>
            <HomeIcon /> / Orders / Review Order
          </p>
        </header>

        <div className="review_order_btns">
          <button className="btn" aria-label="Email Order">Email</button>
          <button className="btn" aria-label="Download PDF">PDF</button>
          <button className="btn" aria-label="Edit Order">Edit</button>
          <button className="btn" aria-label="Long PDF Options">Only for long PDF</button>
        </div>

        <div className="review_order_outer">
          <div className="review_order_item">
            <div className="review_order_header">
              <div className="logo">
                <img src={Logo} alt="" />
              </div>
              <div className="customer_review_details">
                <div className="item_row">
                  <p className="label">Customer Name / ชื่อลูกค้า</p>
                  <p className="value">Roshni test</p>
                </div>
                <div className="item_row">
                  <p className="label">Order No / ใบสั่งซื้อ</p>
                  <p className="value">AR16528 - CH / Pant</p>
                </div>
                <div className="item_row">
                  <p className="label">Fabric No / เบอร์ผ้า</p>
                  <p className="value">cotton</p>
                </div>
                <div className="item_row">
                  <p className="label">Lining No / เบอร์ผ้าซับใน</p>
                  <p className="value">cotton</p>
                </div>
                <div className="item_row">
                  <p className="label">Qty / จํานวน</p>
                  <p className="value">1</p>
                </div>
              </div>
              <div className="order_timing">
                <p>Order Date / วันที่สั่ง</p>
                <p className="order_time">09/12/2024</p>
                <p>Delivery Date / วันที่ส่ง</p>
                <p className="delivery_time">06/01/2025</p>
                <p>Delivery Location</p>
              </div>
            </div>
            <div className="remark_row_outer">
              <p>Remarks: <span>ttest</span></p>
            </div>
            <div className="measurements_values_grid">
              <div className="measure_values_outer">
                <div className="measure_values">
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                  <div className="measure_values_item">
                    <p className="label">JACKET STYLE</p>
                    <p className="value">|</p>
                  </div>
                </div>
                <div className="review_style_remark">
                  <p>Style Remarks :</p>
                  <p className="value"></p>
                </div>
              </div>
              <div className="customer_measurement_details">
                <h4>Jacket Measurement</h4>
                <div className="measerment_with_values">
                  <p>Sex : <span></span></p>
                  <p>Measurement | วัดตัว: <span></span></p>
                  <p>Front Length | ยาวหน้า: <span></span></p>
                  <p>First Button : <span></span></p>
                  <p>Chest | อก: <span></span></p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </Layout>
  );
}

export default ReviewPage;
